import { render, staticRenderFns } from "./FlightSearch.vue?vue&type=template&id=fc004dca&scoped=true&"
import script from "./FlightSearch.vue?vue&type=script&lang=js&"
export * from "./FlightSearch.vue?vue&type=script&lang=js&"
import style0 from "./FlightSearch.vue?vue&type=style&index=0&id=fc004dca&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc004dca",
  null
  
)

export default component.exports